import axios from 'axios'
import qs from 'qs'


export function testFetch(url, data) {
  //clear server interface
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(data))
      .then(response => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export default {
    weChatConfigParams(data) {
        return testFetch('https://api.eastfair.com/wechat/client/signature', data);
    },

}